import React from 'react';
import Navbar from '../Navbar2';
import Contact from '../Contact';
import Register from '../Register';
import './index.css';

const ClubDetail = () => {
  return (
    <div className="club-page">
      <Navbar />

      {/* Hero */}
      <div className="club-hero">
        <div className="club-hero-overlay" />
        <div className="club-hero-content">
          <p className="club-hero-label">Exclusive Membership</p>
          <h1 className="club-hero-title">Curated Membership,<br />for the Discerning</h1>
          <p className="club-hero-sub">
           A private circle with privileged access to Luxe Unbounded residences.
Created for those who value space, privacy, and a sense of belonging.
          </p>
        </div>
      </div>

      {/* Intro */}
      <div className="club-intro-section">
        <div className="club-intro-inner">
          <p className="club-intro-label">About The Club</p>
          <h2 className="club-intro-title">A Smarter Way to Own Luxury</h2>
          <p className="club-intro-text">
            A Travel Unbounded Initiative — Club membership represents a financial investment exclusively available to high-net-worth individuals and sophisticated investors. Access an expanding collection of meticulously curated villas in the world's most sought-after destinations, at a fraction of the usual cost.
          </p>
        </div>
      </div>

      {/* Sections */}
      <div className="club-sections-wrap">

        {/* Section 1 — text left, image right */}
        <div className="club-hs-section">
          <div className="club-hs-text">
            <p className="club-hs-label">Ownership</p>
            <h2 className="club-hs-title">Shared Luxury Holiday Home Ownership</h2>
            <p className="club-hs-desc">
              Own a piece of the world's finest Club homes at a fraction of the price. As a member, you co-own a share of the entire portfolio within your chosen collection — giving you direct exposure to the portfolio's appreciation in value over time.
            </p>
          </div>
          <div className="club-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fshared.webp?alt=media&token=e125deba-2d83-4a2f-ad51-da0862c210e6"
              alt="Shared Ownership"
            />
          </div>
        </div>

        {/* Section 2 — image left, text right */}
        <div className="club-hs-section">
          <div className="club-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fat-your-service.webp?alt=media&token=501c6fa8-2875-4736-b871-75582c532208"
              alt="At Your Service"
            />
          </div>
          <div className="club-hs-text">
            <p className="club-hs-label">Concierge</p>
            <h2 className="club-hs-title">At Your Service</h2>
            <p className="club-hs-desc">
              We learn your desires, so your escape unfolds the moment you book, leaving you free to bask in the peace of a getaway already in motion. Our dedicated concierge team handles every detail with precision and care.
            </p>
          </div>
        </div>

        {/* Section 3 — text left, image right */}
        <div className="club-hs-section">
          <div className="club-hs-text">
            <p className="club-hs-label">Access</p>
            <h2 className="club-hs-title">Homes for All Seasons</h2>
            <p className="club-hs-desc">
              Unlock exclusive access to a curated collection of Club homes, where owners can carve through winter slopes, bask in sun-drenched summers, embrace the warmth of winter's glow, and retreat to their beloved cities.
            </p>
          </div>
          <div className="club-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fhomes-for-all-seasons.webp?alt=media&token=1a9cc5ed-d15e-4c55-b8c0-32b872715fcc"
              alt="Homes for All Seasons"
            />
          </div>
        </div>

      </div>

      {/* Member Benefits */}
      <div className="club-benefits-section">
        <div className="club-benefits-inner">
          <p className="club-intro-label">Membership Privileges</p>
          <h2 className="club-intro-title">What Do Members Get</h2>
          <p className="club-intro-text">
            Fractional Ownership with Exclusive Privileges — as a member, you'll own a share of the entire portfolio within your chosen collection, giving you direct exposure to the portfolio's appreciation in value over time.
          </p>
          <ol className="club-benefits-list">
            <li>A bespoke, embossed Membership Card</li>
            <li>A share of rental income from your collection's properties, managed by our team</li>
            <li>Guaranteed annual complimentary stay nights at your collection homes</li>
            <li>Access to our specialized Luxury Travel Concierge services</li>
            <li>Preferential rates on upcoming property collections</li>
          </ol>
        </div>
      </div>

      {/* Register + Footer */}
      <Register />
      <Contact />
    </div>
  );
};

export default ClubDetail;
